import { useState } from 'react';

export default function Pricing() {
  const scrollToForm = () => {
    const formSection = document.getElementById('pricing-section');
    if (formSection) {
      formSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="pricing-section" className="py-20 bg-gradient-to-br from-purple-50 via-white to-lavender-50">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        {/* Título Chamativo */}
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-5xl font-bold text-gray-900 mb-4 font-montserrat">
            🔥 Sua chance de entrar na <span className="text-purple-600">Mentoria Team RB</span> com desconto especial
          </h2>
        </div>
        
        {/* Card Principal da Oferta */}
        <div className="bg-white rounded-3xl p-8 lg:p-12 shadow-xl border border-purple-100 mb-8 relative overflow-hidden">
          
          {/* Ancoragem de Preço */}
          <div className="text-center mb-8">
            <div className="mb-4">
              <span className="text-2xl lg:text-3xl font-semibold text-purple-300 line-through font-montserrat">R$ 200</span>
              <span className="ml-3 inline-flex items-center px-3 py-1 bg-red-100 text-red-600 rounded-full text-sm font-semibold font-poppins">
                -25% OFF
              </span>
            </div>

            <div className="mb-4 relative inline-block">
              <div className="absolute inset-0 bg-purple-600/10 blur-xl rounded-full"></div>
              <div className="relative">
                <span className="text-5xl lg:text-7xl font-bold text-purple-600 font-montserrat">R$ 149</span>
              </div>
            </div>

            <p className="text-sm text-orange-600 font-medium font-poppins bg-orange-50 inline-block px-4 py-2 rounded-full">
              ⚡ Oferta válida enquanto houver vagas
            </p>
          </div>

          {/* Lista de Benefícios */}
          <div className="bg-gradient-to-br from-purple-50 to-white rounded-2xl p-6 lg:p-8 mb-8">
            <div className="grid md:grid-cols-2 gap-4">
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 flex items-center justify-center bg-purple-100 rounded-full flex-shrink-0">
                  <i className="ri-user-settings-line text-purple-600"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 font-poppins">Treino personalizado</h4>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 flex items-center justify-center bg-blue-100 rounded-full flex-shrink-0">
                  <i className="ri-video-line text-blue-600"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 font-poppins">Correção de execução</h4>
                </div>
              </div>

              <div className="flex items-start space-x-3 md:col-span-2">
                <div className="w-8 h-8 flex items-center justify-center bg-purple-100 rounded-full flex-shrink-0">
                  <i className="ri-customer-service-2-line text-purple-600"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 font-poppins">Suporte direto por 30 dias</h4>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Destacado */}
          <div className="text-center space-y-3 mb-8">
            <a 
              href="https://pay.kiwify.com.br/U9K6YXB" 
              target="_blank" 
              rel="noopener noreferrer"
              className="block w-full bg-purple-700 hover:bg-purple-800 text-white font-bold text-lg lg:text-xl py-5 px-8 rounded-xl transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer font-poppins"
            >
              Garantir Minha Vaga!
            </a>
            
            <p className="text-sm text-orange-600 font-medium font-poppins bg-orange-50 inline-block px-4 py-2 rounded-full">
              Vagas limitadas
            </p>
          </div>

          {/* Copy Persuasiva */}
          <div className="bg-gradient-to-r from-gray-50 to-purple-50 rounded-xl p-6 mb-8 text-center">
            <p className="text-gray-700 font-inter leading-relaxed">
              Treinar sozinha te faz perder tempo. Com acompanhamento certo, você evolui mais rápido e com segurança — e agora por um valor especial.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
